import { getContext, setContext } from 'svelte'
import { writable } from 'svelte/store'

export const TRANSLATIONS = Symbol('translations')

export const LANGUAGE = Symbol('language')

/**
 * @param {string} lang
 */
export function setLanguage(lang) {
  const store = getContext(LANGUAGE)
  if (store) store.set(lang)
  else setContext(LANGUAGE, writable(lang))
}

/**
 * @returns {import('svelte/store').Writable<string>}
 */
export function getLanguage() {
  return getContext(LANGUAGE)
}

export const CURRENCY = Symbol('currency')

/**
 * @param {string} lang
 */
export function setCurrency(lang) {
  const store = getContext(CURRENCY)
  if (store) store.set(lang)
  else setContext(CURRENCY, writable(lang))
}

/**
 * @returns {import('svelte/store').Writable<string>}
 */
export function getCurrency() {
  return getContext(CURRENCY)
}
